import { React } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

const InfoPagination = (props) => {
  const { bottomMargin, nowPage, totalPage, nextClickFn, prevClickFn } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  return (
    <TopLevelWrapper /*bottomMargin={bottomMargin}*/>
      <Button onClick={prevClickFn}>{t('main.notice.prevPage')}</Button>
      <Page color={theme.text}>{nowPage + 1}/{totalPage}</Page>
      <Button onClick={nextClickFn}>{t('main.notice.nextPage')}</Button>
    </TopLevelWrapper>
  )
}

export default InfoPagination;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  margin-bottom: 96px;
  // margin-bottom: ${props => props.bottomMargin}px;
`;

const Button = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.line};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.text};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Page = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.color || props.theme.text};

  margin: 0 10px 0 10px;
`;
